import React, { useEffect, useMemo, useState } from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import BlogCard from '../components/bloog/BlogCard';
import apis from '../utils/apis';
import httpAction from '../utils/httpAction';
import EmptyState from '../components/common/EmptyState';
import { CardSkeleton, SkeletonText } from '../components/common/Skeleton';
import { resolveMedia } from '../utils/media';
import './Blog.css'
export default function Blog() {
  const [page, setPage] = useState(1);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const perPage = 6;

  useEffect(() => {
    setLoading(true);
    httpAction({ url: apis().blogList, silent: true }).then((result) => {
      if (result?.status) setPosts(result.list || []);
      setLoading(false);
    });
  }, []);

  const featured = useMemo(() => posts.find((item) => item.featured) || posts[0], [posts]);
  const paged = useMemo(() => posts.slice((page - 1) * perPage, page * perPage), [posts, page]);
  const totalPages = Math.max(1, Math.ceil(posts.length / perPage));

  if (loading) return <div className="container" style={{ padding: '120px 0 60px' }}><SkeletonText width="300px" height={36} /><div style={{ marginTop: 24 }}><CardSkeleton count={3} height={300} /></div></div>;
  if (!posts.length) return <div className="container" style={{ padding: '120px 0 60px' }}><EmptyState title="No blog posts published yet" text="Add blog posts from admin panel to show them here." /></div>;

  return (
    <section className="container" style={{ padding: '120px 16px 60px' }}>
      <div style={{ marginBottom: 30 }}>
        <h1 style={{ marginBottom: 10 }}>Latest Articles & Insights</h1>
        <p style={{ color: '#667085', maxWidth: 700 }}>Read market updates, project highlights, guides, and real estate insights published from the admin panel.</p>
      </div>

      {featured && (
        <div className="blog-featured">
          <img
            src={resolveMedia(featured.coverImage)}
            alt={featured.title}
            className="blog-featured-image"
          />
          <div className="blog-featured-content">
            <div style={{ color: '#0f5ef7', fontWeight: 700, marginBottom: 10 }}>
              {featured.category || 'Featured'}
            </div>
            <h2 style={{ marginBottom: 10 }}>{featured.title}</h2>
            <p style={{ color: '#667085', marginBottom: 18 }}>{featured.excerpt}</p>
            <a
              href={`/blog/${featured.slug}`}
              style={{ color: '#0f5ef7', fontWeight: 700, textDecoration: 'none' }}
            >
              Read Featured <FiArrowUpRight />
            </a>
          </div>
        </div>
      )}

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: 20,
        }}
      >
        {paged.map((post) => <BlogCard key={post._id} item={post} />)}
      </div>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 12,
          marginTop: 28,
        }}
      >
        <button
          onClick={() => setPage((p) => Math.max(1, p - 1))}
          disabled={page === 1}
          className="pagination-button"
        >
          Prev
        </button>
        <span style={{ fontWeight: 'bold' }}>
          Page {page} of {totalPages}
        </span>
        <button
          onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
          disabled={page === totalPages}
          className="pagination-button"
        >
          Next
        </button>
      </div>
    </section>
  );
}